// extracted by mini-css-extract-plugin
export default {"appIconWrapper":"uwjkyL9vYD","appIconWrapper_deletedApp":"uo4nvcJlZA","appIcon":"Pg85Gqn3tk"};